import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetMetricsState from './datasetMetrics';
import updateDatasetSettingsState from './datasetSettings';
import updateDatasetState from './dataset';

const handlers = {
  ...updateDatasetMetricsState,
  ...updateDatasetSettingsState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
